export default "__VITE_ASSET__0ac9bc02__"